import React from 'react'
import { motion } from 'framer-motion'

export function KickstarterHero() {
  return (
    <>
      {/* Hero Section */}
      <section className="relative pt-32 pb-24 overflow-hidden min-h-[500px] flex items-center">
        <div className="absolute inset-0 z-0 bg-background">
          <div className="relative w-full h-full">
            <img
              src="/images/backgrounds/flickr-237097140.jpg"
              alt="AI Innovation"
              className="object-cover hero-bg w-full h-full"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background/70 to-background" />
          </div>
        </div>

        <div className="container relative z-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="max-w-3xl mx-auto text-center space-y-6 pt-8"
          >
            <h1 className="text-2xl font-light tracking-tight sm:text-3xl md:text-4xl lg:text-5xl text-foreground/90 leading-tight">
              AI Kickstarter:<br />Build Your AI Advantage
            </h1>
            <p className="text-xl text-muted-foreground font-light">
              Most AI initiatives fail because they focus on tools, not knowledge. AI is only as good as what it knows - and right now, it doesn't know your organisation.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-16">
        <div className="container">
          <div className="max-w-3xl mx-auto space-y-6">
            <p className="text-lg text-muted-foreground leading-relaxed">
              Unlike AI platforms where you upload documents and hope for the best, the AI Kickstarter is consultant-led. Our team works directly with your people over 8 weeks - capturing the knowledge that matters, structuring it properly and building AI that actually understands your operations. This three-phase approach delivers strategic clarity, operational AI capability and measurable results.
            </p>
          </div>
        </div>
      </section>
    </>
  )
}
